const customStyles = {
  control: (base: any) => ({
    ...base,
    textAlign: "left",
    marginTop: "7px",
    paddingLeft: "3px",
    padding: "2px",
    // width: "auto",
    flex: "1",
    border: "1px solid #919191",
    height: "45px",
    // "@media only screen and (max-width: 720px)": {
    //   width: "150px",
    // }    
  }),

  menu: (base: any) => ({
    ...base,
    textAlign: "left",
    width: "max-content",
  }),

  placeholder: (base: any) => ({
    ...base,
    color: "#333333"
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    padding: "15px 15px",
    color: "#9a7cc5",
    backgroundColor: "#fff",
    borderRadius: "4px",
    margin: "2px",
    display: "block",
    width: "99%",

    "&:hover": {
      backgroundColor: "#9a7cc5",
      borderRadius: "8px",
      color: "#fff",
      cursor: "pointer",
      textDecoration: "underline",
    },
  }),
};

export default customStyles;
